<template>
    <div>
        <section class="xlrclh">
            <img class="top-img" src="./../assets/imgs/65/title-bg.png" alt="" />
            <div class="technological-process">
                <div class="sxcl">
                    <img class="top" src="./../assets/imgs/65/title-1.png" alt="" />
                    <div class="content">
                        为崇州市属教育卫生事业单位、在崇州注册并纳税的非公有制企业、在崇州登记的社会组织等用人主体3年以上的全职在岗人员
                    </div>
                </div>
                <div class="zccl">
                    <img class="top" src="./../assets/imgs/65/title-2.png" alt="" />
                    <div class="content">
                        <div style="font-size: 0.34rem; font-weight: bold">
                            <span class="hollow-cricle"></span>（一）常规项目
                        </div>
                        <div class="des" style="margin-top: 0.15rem; margin-bottom: 0.5rem">
                            <div>
                                <span style="font-weight: Bold">1.现代农业产业优秀人才。</span>主要支持现代种业、粮油产业、绿色食品等产业细分领域人才。
                            </div>
                            <div>
                                <span style="font-weight: Bold">2.先进制造业产业优秀人才。</span>主要支持消费电子、智能终端、智能家居、新型材料等细分行业人才。
                            </div>
                            <div>
                                <span
                                    style="font-weight: Bold">3.文化和旅游产业优秀人才。</span>主要支持在文旅投资、旅游住宿、旅游综合服务、文化创意产品开发或在哲学社科、文化艺术、出版传媒、新闻舆论、体育事业等公共文化服务领域等人才。
                            </div>
                            <div>
                                <span style="font-weight: Bold">4.科技创新优秀人才。</span>主要支持在我市工业、农业领域长期从事研究开发、科技管理服务人才。
                            </div>
                            <div>
                                <span style="font-weight: Bold">5.乡村振兴优秀人才。</span>主要支持在我市农业生产一线和农村经济社会发展中直接从事生产、经营、服务等活动人才。
                            </div>
                            <div>
                                <span style="font-weight: Bold">6.优秀技能人才。</span>主要支持职业技能处于全市同行业领先水平人才。
                            </div>
                            <div>
                                <span style="font-weight: Bold">7.城乡治理优秀人才。</span>主要支持从事社区发展治理、智慧治理和法治崇州建设等领域工作人才。
                            </div>
                            <div>
                                <span style="font-weight: Bold">8.教育优秀人才。</span>主要支持长期从事教育教学、教育管理、教育教学研究一线工作人才。
                            </div>
                            <div>
                                <span style="font-weight: Bold">9.医疗卫生优秀人才。</span>主要支持在全市医疗卫生领域和社会享有较高声望的人才。
                            </div>
                        </div>
                        <div style="font-size: 0.34rem; font-weight: bold">
                            <span class="hollow-cricle"></span>（二）前置改革项目
                        </div>
                        <div class="des" style="margin-top: 0.15rem">
                            属新引进落地并经崇州市推荐、成都市认定的重大招商引资项目或总部企业的用人单位(须为2021年1月1日后在崇州注册落地的企业&lt项目>)，可推荐一定名额的人选直接纳入“蜀城英才计划”优秀人才项目，享受相关政策待遇。
                        </div>
                    </div>
                </div>
                <div class="zccl">
                    <img class="top" src="./../assets/imgs/65/title-3.png" alt="" />
                    <div class="content">
                        <div class="des">
                            <div class="title">一. 资金支持</div>
                            依托崇州市人才发展专项资金，给予每人4万元的资助。资助资金按5:5比例分两年拨付，在年度考核结束后1个月内拨付完成，主要用于入选者及其团队从事技术研发、成果转化、市场推广、培训进修等，可适当用于改善入选者工作生活条件。用人单位可结合实际额外给予适当的资金和政策激励。
                        </div>
                        <div class="des">
                            <div class="title">二. 创新创业支持</div>
                            用人单位应注重吸收入选人员参与重大项目咨询、重大科技计划和行业标准制定等工作。市级有关部门应充分发挥政府投资引导基金作用，用好壮大贷、科创贷、创业贷等金融产品,加大入选者创业创新的金融支持力度。
                        </div>
                        <div class="des">
                            <div class="title">三. 研修培训支持</div>
                            定期选派部分入选者参加高层次人才国情研修班,提供到知名大学、研究机构学习考察调研机会。用人单位应优先支持入选者参加本行业本系统重要学术交流、赴外研修访问活动。
                        </div>
                        <div class="des">
                            <div class="title">四. 其它服务</div>
                            为入选人员配发“蓉城人才绿卡（州卡）崇”，凭卡按规定享受政务导办、交通出行、参观游览等服务政策。每年安排入选人员健康体检。发挥崇州市人才发展促进会联系服务功能，为入选者提供联谊交流、走访慰问、项目申报、资源对接等专属服务。
                        </div>
                    </div>
                </div>
                <div class="sbcl">
                    <img class="top" src="./../assets/imgs/65/title-4.png" alt="" />
                    <div class="content">
                        <div style="font-size: 0.34rem; font-weight: bold">
                            <span class="hollow-cricle"></span>（一）组织评审
                        </div>
                        <div class="des" style="margin-top: 0.15rem; margin-bottom: 0.5rem">
                            <div class="item">
                                <div class="line"></div>
                                <div class="dot">1</div>
                                制发遴选公告
                            </div>
                            <div class="item">
                                <div class="line"></div>
                                <div class="dot">2</div>
                                公示
                            </div>
                            <div class="item">
                                <div class="line"></div>
                                <div class="dot">3</div>
                                初评
                            </div>
                            <div class="item">
                                <div class="dot">4</div>
                                背景审查
                            </div>
                            <div class="item">
                                <div class="dot">5</div>
                                终评
                            </div>
                            <div class="item">
                                <div class="dot">6</div>
                                审定
                            </div>
                        </div>
                        <div style="font-size: 0.34rem; font-weight: bold">
                            <span class="hollow-cricle"></span>（二）项目(企业)举荐（适用于前置改革项目）
                        </div>
                        <div class="des" style="margin-top: 0.15rem">
                            <div class="item">
                                <div class="line"></div>
                                <div class="dot">1</div>
                                确定举荐名额
                            </div>
                            <div class="item">
                                <div class="line"></div>
                                <div class="dot">2</div>
                                发布遴选公告
                            </div>
                            <div class="item">
                                <div class="line"></div>
                                <div class="dot">3</div>
                                企业开展自评
                            </div>
                            <div class="item">
                                <div class="dot">4</div>
                                初审
                            </div>
                            <div class="item">
                                <div class="dot">5</div>
                                背景审查
                            </div>
                            <div class="item">
                                <div class="dot">6</div>
                                审定
                            </div>
                        </div>
                    </div>
                </div>

                <div class="sxcl">
                    <img class="top" src="./../assets/imgs/65/title-5.png" alt="" />
                    <div class="content" style="font-size: 0.3rem; font-weight: bold">
                        每两年评选一次，依据具体通知时间确定。
                    </div>
                </div>
                <div class="call">
                    <img class="top" src="./../assets/imgs/65/title-6.png" alt="" />
                    <div class="content" style="font-size: 0.27rem; font-weight: bold">
                        <div class="left">
                            <div class="item">
                                <span class="label">中共崇州市委组织部人才工作科</span>
                                <a href="tel:028-82228953" class="number">028-82228953</a>
                            </div>
                            <div class="item">
                                <span class="label">农业领域人才/市农业农村局</span>
                                <a href="tel:028-82380292" class="number">028-82380292</a>
                            </div>
                            <div class="item">
                                <span class="label">大数据领域人才/市大数据局</span>
                                <a href="tel:028-82275717" class="number">028-82275717</a>
                            </div>
                            <div class="item">
                                <span class="label">文化体育旅游领域人才/市文旅局</span>
                                <a href="tel:028-82213911" class="number">028-82213911</a>
                            </div>
                            <div class="item">
                                <span class="label">教育领域人才/市教育局</span>
                                <a href="tel:028-82310830" class="number">028-82310830</a>
                            </div>
                            <div class="item">
                                <span class="label">医疗卫生领域人才/市卫健局</span>
                                <a href="tel:028-82201900" class="number">028-82201900</a>
                            </div>
                            <div class="item">
                                <span class="label">经营管理领域人才/市新经科局</span>
                                <a href="tel:028-82272411" class="number">028-82272411</a>
                            </div>
                            <div class="item">
                                <span class="label">科技创新领域人才/市新经科局</span>
                                <a href="tel:028-82272411" class="number">028-82272411</a>
                            </div>
                            <div class="item">
                                <span class="label">社会工作领域人才/市民政局</span>
                                <a href="tel:028-82272243" class="number">028-82272243</a>
                            </div>
                            <div class="item">
                                <span class="label">创新创业领域人才/市人社局</span>
                                <a href="tel:028-82272297" class="number">028-82272297</a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="codes">
                    <img class="code" src="../assets/imgs/65/code.png" />
                    <img class="text" src="../assets/imgs/65/text.png" />
                </div>
            </div>
        </section>
        <!-- <call phone="028-83221725"></call> -->
    </div>
</template>

<script>
export default {
    data() {
        return {};
    },



    mounted() { },

    methods: {},
};
</script>
<style lang="scss" scoped>
@import "@/assets/public.scss";

.xlrclh {
    background-color: $base-back;

    .top-img {
        width: 7.26rem;
        height: 5.6rem;
    }

    .technological-process {
        transform: translateY(-1.9rem);

        .sxcl {
            position: relative;
            margin-top: 0.22rem;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #fff;
                margin: -0.45rem auto 0;
                padding: 0.33rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;
                padding-top: 0.28rem;
                font-size: 0.26rem;
                font-weight: 500;
                text-align: left;
                color: #4e4e4e;
                line-height: 0.44rem;

            }
        }

        .call {
            position: relative;
            margin-top: 0.22rem;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #fff;
                margin: -0.45rem auto 0;
                padding: 0.33rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;
                padding-top: 0.28rem;
                font-size: 0.26rem;
                // font-weight: 500;
                text-align: left;
                color: #4e4e4e;
                display: flex;
                align-items: center;

                .left {
                    width: 100%;

                    // background-color: red;
                    .item {
                        margin-top: 0.15rem;
                        display: flex;
                        align-items: center;
                        // justify-content: space-between;

                        .label {
                            width: 4.2rem;

                            // font-weight: normal;

                        }

                        .number {
                            font-weight: normal;
                            font-size: 0.25rem;
                        }
                    }
                }
            }
        }

        .zccl {
            position: relative;
            margin-top: 0.22rem;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #e8eeff;
                margin: -0.45rem auto 0;
                padding: 0.33rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;
                padding-top: 0.28rem;
                font-size: 0.26rem;
                font-weight: 500;
                text-align: left;
                color: #4e4e4e;

                .des {
                    color: #4e4e4e;
                    background: #ffffff;
                    border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
                    padding: 0.35rem 0.23rem 0.3rem;
                    margin-top: 0.8rem;
                    position: relative;
                    text-align: left;

                    .title {
                        position: absolute;
                        top: -0.5rem;
                        left: 50%;
                        transform: translateX(-50%);
                        width: 2.98rem;
                        height: 0.67rem;
                        line-height: 0.67rem;
                        display: flex;
                        justify-content: center;
                        align-content: center;
                        font-size: 0.32rem;
                        font-weight: bold;
                        color: #ffffff;
                        border-radius: 1rem;
                        background-color: #739bfe;
                    }
                }
            }
        }

        .sbcl {
            position: relative;
            margin-top: 0.22rem;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #e8eeff;
                margin: -0.45rem auto 0;
                padding: 0 0.33rem 0.64rem 0.36rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;
                padding-top: 0.28rem;
                font-size: 0.26rem;
                font-weight: 500;
                text-align: left;
                color: #4e4e4e;

                .des {
                    color: #4e4e4e;
                    text-align: left;
                    background: #ffffff;
                    border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
                    padding: 0.35rem 0.23rem 0.3rem;
                    margin-top: 0.8rem;
                    position: relative;

                    .title {
                        position: absolute;
                        top: -0.5rem;
                        left: 50%;
                        transform: translateX(-50%);
                        width: 4.5rem;
                        height: 0.67rem;
                        line-height: 0.67rem;
                        display: flex;
                        justify-content: center;
                        align-content: center;
                        font-size: 0.24rem;
                        font-weight: bold;
                        color: #ffffff;
                        border-radius: 1rem;
                        background-color: #739bfe;
                    }

                    .item {
                        margin-top: 0.35rem;
                        box-sizing: border-box;
                        position: relative;
                        padding-left: 0.42rem;
                        display: flex;

                        .line {
                            position: absolute;
                            width: 0.02rem;
                            height: 135%;
                            border-left: 0.02rem dashed #739bfe;
                            left: 0.1rem;
                            top: 0.2rem;
                            z-index: 0;
                            //   background-color: #739bfe;
                        }

                        .dot {
                            width: 0.39rem;
                            height: 0.39rem;
                            background-color: #739bfe;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            font-size: 0.28rem;
                            color: #fff;
                            border-radius: 50%;
                            position: absolute;
                            left: -0.1rem;
                            top: 0;
                            z-index: 9999;
                        }
                    }
                }
            }
        }

        .codes {
            margin: 0 auto;
            margin-top: 0.25rem;
            width: 6.85rem;
            background: #fff;
            padding: 0.3rem;
            box-sizing: border-box;
            border-radius: 0.26rem;
            padding-top: 0.28rem;
            font-size: 0.26rem;
            font-weight: 500;
            color: #4e4e4e;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .code {
                width: 1.94rem;
                height: 1.94rem;
            }

            .text {
                height: 1.65rem;
            }
        }
    }
}
</style>
